import React, { useState } from "react"
import ProductGalleryViewer from "./ProductGalleryViewer"
import { preventBodyScroll } from "@/utils/helper"
import Modal from "@/components/core/Modal/Modal"
import ImageGalleryHorizontal from "../ProductDetailView/ImageGallery/ImageGalleryHorizontal"

const ProductGalleryView = props => {
  const [showModal, setShowModal] = useState(false)
  const presetConfigObject =
    typeof props.presetConfig === "string"
      ? JSON.parse(props.presetConfig)
      : props.presetConfig

  const handleModalPopup = () => {
    setShowModal(true)
    document.body.classList.add("image-gallery-modal-opened")
  }
  const { pdpData } = props
  const pdpDetails = pdpData ?? {}
  const { pdpDesktopImage } = pdpDetails
  let placeholderImage = []

  if (pdpDesktopImage) {
    placeholderImage[0] = {
      label: " ",
      template: "LandscapeCategory",
      url: pdpDesktopImage,
    }
  }

  const onModalClose = () => {
    setShowModal(false)
    document.body.classList.remove("image-gallery-modal-opened")
    document.body.classList.remove("scroll-lock")
    preventBodyScroll(false)
  }

  const isMobileDevice = window.innerWidth < 840
  let resourceTmpCredits =
    props &&
    props.productGalleryLabel &&
    props.productGalleryLabel.resourceCredit_s &&
    props.productGalleryLabel.resourceCredit_s.match("http") == null
      ? props.productGalleryLabel.resourceCredit_s
      : ""
  let showSku =
    props &&
    props.productData &&
    props.productData.category.match("Samples") !== null
      ? "SKU: " + props.productData.sku
      : ""
  let resourceCredits = showSku ? showSku : resourceTmpCredits
  const queryParams = new URLSearchParams(window.location.search);
  const productDetailsForImage = props.productData && (props.productData.name + " " +  props.productData.desc + " " + "in" + " " + props.imageColorDetails) ;

  return (
    <React.Fragment>
      {isMobileDevice ? (
        <div className="mobile-gallery" id="imageGallery">
          <ImageGalleryHorizontal
            {...props}
            placeholderImage={placeholderImage}
            presetConfigObject={presetConfigObject}
            isPopup={false}
            handlePopup={handleModalPopup}
            galleryStackId="image-gallery__image-stack-gallery"
            showBadges={true}
            showPhotoCredit="1"
            resourceCredits={resourceCredits}
            productDetailsForImage = {productDetailsForImage}
          />
        </div>
      ) : (
        <ProductGalleryViewer
          {...props}
          presetConfigObject={presetConfigObject}
          handlePopup={handleModalPopup}
          placeholderImage={placeholderImage}
          productDetailsForImage = {productDetailsForImage}
        />
      )}

      {showModal && (
        <Modal onModalClose={onModalClose} showModal={showModal}>
          <div className="image-gallery-container">
            <ImageGalleryHorizontal
              {...props}
              presetConfigObject={presetConfigObject}
              isPopup={true}
              galleryStackId="image-gallery__image-stack-kohler"
              placeholderImage={placeholderImage}
            />
          </div>
        </Modal>
      )}
    </React.Fragment>
  )
}

export default ProductGalleryView
